module.exports = __webpack_public_path__ + "img/79.b2334f7c.jpg";